import styles from './styles.module.scss'
import {
  Column,
  ColumnContent,
  ColumnHeader
} from '@components/account/shared/Column'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { useState } from 'react'
import { Address } from '@components/account/types'
import { PersonalDetail } from './PersonalDetail'
import { AddressDetail } from './AddressDetail'
import { AccountDetailsDrawer } from './drawer'
import { useAuth } from '@api/accounts/auth/hooks/useAuth'
import { EMPTY_FIELD_VALUE } from '@consts/index'
import { Button } from '@components/ui/Button'

function AddressEmpty() {
  return (
    <address className={styles.AddressRow}>
      <p>No addresses yet</p>
    </address>
  )
}

function addressList(addresses: Address[], defaultAddress?: Address) {
  if (!addresses.length || !defaultAddress) return []
  return addresses
    .map(address => ({
      ...address,
      defaultAddress: address.id === defaultAddress.id
    }))
    .sort((a, b) => (b.defaultAddress ? 1 : 0) - (a.defaultAddress ? 1 : 0))
}

type FormDataMap = {
  details: {
    firstName?: string
    lastName?: string
    phoneNumber?: string
    email?: string
    id?: string
  }
  address: Address
  defaultAddress: Address
  'add address': null
}

function AccountDetails() {
  const [drawerState, setDrawerState] = useState<{
    show: boolean
    type: keyof FormDataMap | ''
    data: FormDataMap[keyof FormDataMap] | null
  }>({
    show: false,
    type: '',
    data: null
  })

  const { userProfile } = useAuth()

  const addresses = addressList(
    userProfile?.addresses || [],
    userProfile?.defaultAddress
  )

  const handleOpen = <T extends keyof FormDataMap>(
    type: T,
    data: FormDataMap[T]
  ) => {
    setDrawerState({
      show: true,
      type,
      data
    })
  }

  const handleCloseAccountDetailsDrawer = () => {
    setDrawerState({
      show: false,
      type: '',
      data: null
    })
  }

  return (
    <>
      <div className={styles.AccountDetails}>
        <div className={styles.AccountDetails__column}>
          <Column>
            <ColumnHeader title="Personal">
              <ButtonMinimal
                underlined={true}
                variant="primary"
                onClick={() =>
                  handleOpen('details', {
                    firstName: userProfile?.firstName,
                    lastName: userProfile?.lastName,
                    email: userProfile?.emailAddress?.emailAddress,
                    phoneNumber: userProfile?.phoneNumber?.phoneNumber,
                    id: userProfile?.id
                  })
                }
              >
                Edit
              </ButtonMinimal>
            </ColumnHeader>
            <ColumnContent>
              <PersonalDetail
                label="First Name"
                value={userProfile?.firstName || EMPTY_FIELD_VALUE}
              />
              <PersonalDetail
                label="Last Name"
                value={userProfile?.lastName || EMPTY_FIELD_VALUE}
              />
              <PersonalDetail
                label="Phone number"
                value={
                  userProfile?.phoneNumber?.phoneNumber || EMPTY_FIELD_VALUE
                }
              />
              <PersonalDetail
                label="Email Address"
                value={
                  userProfile?.emailAddress?.emailAddress || EMPTY_FIELD_VALUE
                }
              />
            </ColumnContent>
          </Column>
        </div>
        <div className={styles.AccountDetails__column}>
          <Column>
            <ColumnHeader title="Address Book"></ColumnHeader>
            <ColumnContent>
              <div
                className={`${styles.AddressContainer} ${
                  addresses.length > 2 ? styles.AddressContainer__multiple : ''
                }`}
              >
                {addresses.length ? (
                  <>
                    {addresses.map((address, index) => (
                      <AddressDetail
                        address={address}
                        key={`${address.zip}-${index}`}
                        onHandleOpen={handleOpen}
                      />
                    ))}
                    {addresses.length > 2 && (
                      <span className={styles.AddressContainer__spacer}></span>
                    )}
                  </>
                ) : (
                  <AddressEmpty />
                )}
              </div>
              <Button
                onClick={() => handleOpen('add address', null)}
                variant="secondary"
                fullWidth="always"
              >
                + Add an Address
              </Button>
            </ColumnContent>
          </Column>
        </div>
      </div>
      <div className={styles.AccountDetailsDrawer}>
        <AccountDetailsDrawer
          drawerState={drawerState}
          handleCloseAccountDetailsDrawer={handleCloseAccountDetailsDrawer}
        />
      </div>
    </>
  )
}
export default AccountDetails
